import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { AllocationOverview } from '../../api.js';
import { AllocationPanel } from '../../components/AllocationPanel.js';
import type { SubjectKind } from './AllocationsScreen.js';

export interface AllocationSubjectOption {
  id: string;
  label: string;
}

interface SubjectAllocationPanelProps {
  subjectKind: SubjectKind;
  subjectId: string;
  subjects: AllocationSubjectOption[];
  subjectAllocation?: AllocationOverview;
  credit: string;
  busy: boolean;
  onSubjectKindChange: (kind: SubjectKind) => void;
  onSubjectIdChange: (id: string) => void;
  onCreditChange: (credit: string) => void;
  onSave: (event: FormEvent) => void;
}

export function SubjectAllocationPanel({
  subjectKind,
  subjectId,
  subjects,
  subjectAllocation,
  credit,
  busy,
  onSubjectKindChange,
  onSubjectIdChange,
  onCreditChange,
  onSave
}: SubjectAllocationPanelProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="panel toolbar-form subject-allocation-form">
        <h2>{t('allocations.subject')}</h2>
        <label><span id="allocation-subject-kind">{t('allocations.subjectKind')}</span><select aria-labelledby="allocation-subject-kind"
          value={subjectKind}
          onChange={(event) => onSubjectKindChange(event.target.value as SubjectKind)}
          disabled={busy}
        >
          <option value="group">{t('allocations.group')}</option>
          <option value="user">{t('allocations.user')}</option>
        </select></label>
        <label><span id="allocation-subject-target">{t('allocations.subjectTarget')}</span><select aria-labelledby="allocation-subject-target" value={subjectId} onChange={(event) => onSubjectIdChange(event.target.value)} disabled={busy || subjects.length === 0}>
          {subjects.map((subject) => (
            <option key={subject.id} value={subject.id}>
              {subject.label}
            </option>
          ))}
        </select></label>
        {subjects.length === 0 && <span className="muted">{t('allocations.noSubjects')}</span>}
      </div>

      {subjectId && (
        <AllocationPanel
          label={t('allocations.subjectAllocation', { kind: t(`allocations.${subjectKind}`), id: subjectId })}
          {...(subjectAllocation ? { overview: subjectAllocation } : {})}
          credit={credit}
          unlimited={false}
          allowUnlimited={false}
          busy={busy}
          onCreditChange={onCreditChange}
          onSave={onSave}
        />
      )}
    </>
  );
}
